import { render, staticRenderFns } from "./categroy.vue?vue&type=template&id=e6002de2&scoped=true"
import script from "./categroy.vue?vue&type=script&lang=js"
export * from "./categroy.vue?vue&type=script&lang=js"
import style0 from "./categroy.vue?vue&type=style&index=0&id=e6002de2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6002de2",
  null
  
)

export default component.exports